import axios, { AxiosResponse } from 'axios';

const errorUrl = `${process.env.VUE_APP_ROOT_API}/Error`;

export const ErrorService = {
  LogError(msg: string): Promise<AxiosResponse> {
    return axios.post(`${errorUrl}/SendError`, msg);
  }
};
